import Inputmask from './plugins/inputmask';
import { windowResizeAxisX } from './utils.js';

// input mask
(function() {
	var inputPhones = document.querySelectorAll('.js-phone-mask');

	if (inputPhones.length) {
		[].forEach.call(inputPhones, function(inputPhone){
			var im = new Inputmask("+7 (999) 999-99-99");
			im.mask(inputPhone);
		});
	}

	var inputDates = document.querySelectorAll('.js-date-mask');

	if (inputDates.length) {
		[].forEach.call(inputDates, function(inputDate){
			var im = new Inputmask("99.99.9999");
			im.mask(inputDate);
		});
	}
})();

// select2
(function() {	
	$('.js-custom-select__el').each(function(){
		$(this).select2({
			language: "ru",
			templateResult: formatSingleResult,
			dropdownParent: $(this).closest('.js-custom-select')
		});
	});

	function formatSingleResult(state) {
		if (state.element) {
			var parentEl = state.element.closest('.js-custom-select');

			if (parentEl) {
				var searchField = parentEl.querySelector('.select2-search__field');

				if (searchField && searchField.value !== '') {
					var searchVal = searchField.value;

					if (state.text.indexOf(searchVal) !== -1) {
						return $('<span>' + state.text.replace(searchVal, '<b>' + searchVal + '</b>') + '</span>');
					}
				}
			}
		}

		return $('<span>' + state.text + '</span>');
	}
})();

// fixed header
(function() {
	var setHeightToFixedHeader = function() {
		var header = document.querySelector('.js-header');
		var headerFixedHeight = document.querySelector('.js-header-fixed-height');
		
		if (header && headerFixedHeight) {
			headerFixedHeight.style.height = header.offsetHeight + 'px';
		}
	};

	setHeightToFixedHeader();

	windowResizeAxisX(setHeightToFixedHeader);
})();

// mobile menu
(function() {
	var body = document.body;
	var header = document.querySelector('.js-header');
	var burger = document.querySelector('.js-header__burger');
	var mobileMenu = document.querySelector('.js-mobile-menu');
	var mobileMenuClose = document.querySelector('.js-mobile-menu__close');

	if (header && burger && mobileMenu && mobileMenuClose) {
		var getScrollbarWidth = function() {
			return window.innerWidth - document.documentElement.clientWidth;
		};

		burger.addEventListener('click', function() {
			body.style.paddingRight = getScrollbarWidth() + 'px';
			header.style.paddingRight = getScrollbarWidth() + 'px';
			body.classList.add('menu-open');
		});

		mobileMenuClose.addEventListener('click', function() {
			body.style.paddingRight = '';
			header.style.paddingRight = '';
			body.classList.remove('menu-open');
		});
	}
})();

// form validate
(function(){
	var buttons = document.querySelectorAll('.js-send');

	buttons.forEach(function(button) {
		button.addEventListener("click", function(event) {
			var form = button.closest('.js-validate-form');

			if (form && !form.checkValidity()) {
				// Предотвращаем отправку формы путем отмены события
				event.preventDefault();

				var inputs = form.querySelectorAll('input');
				
				inputs.forEach(function(input) {
					if (input.validity.valid) {
						input.classList.remove('input_error');
					} else {
						input.classList.add('input_error');
					}
				});

				var textareas = form.querySelectorAll('textarea');
				
				textareas.forEach(function(textarea) {
					if (textarea.validity.valid) {
						textarea.classList.remove('textarea_error');
					} else {
						textarea.classList.add('textarea_error');
					}
				});
			}
		}, false);
	});
})();

// hide/show form in footer in mobile version
(function() {
	var footerForm = document.querySelector('.js-footer__form');
	var footerFormClose = document.querySelector('.js-footer__form-close');
	var appointmentFormTitle = document.querySelector('.js-appointment-form__title');

	if (footerForm && footerFormClose && appointmentFormTitle) {
		if (window.matchMedia("(max-width: 768px)").matches) {
			appointmentFormTitle.addEventListener('click', function() {
				footerForm.classList.add('show');
			});

			footerFormClose.addEventListener('click', function() {
				footerForm.classList.remove('show');
			});
		}
	}
})();